/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


(function(angular) {
	'use strict';

	angular.module('Core')
			.directive('stlNavBar', [function() {
					return {
						restrict: 'E',
						replace: true,
						transclude: true,
						templateUrl: 'components/core/navbar/navbar.html',
						scope: {
							notification: '&',
							control: '=?',
							ngModel: '=',
							items: '='
						},
						/**
						 * options :
						 * disableSorting : true // disable the table sorting
						 * defaultSortColumn : 'column key name' // the default sorted column
						 * defaultSortDesc : true to sort desc
						 */
						link: function(scope, element, attribute, controller) {
							scope.o = [];
							scope.navbarOpen = true;

							if (scope.ngModel.open !== undefined) {
								scope.navbarOpen = scope.ngModel.open;
							}


							scope.control = function(action, options) {
								if (action === 'setOpen') {
									scope.navbarOpen = options;
								}
							};

							scope.select = function(item) {
								scope.notification({
									action: 'itemSelected',
									options: item
								});
								scope.ngModel.item = item;
							};

							scope.toggleNavbar = function() {
								scope.navbarOpen = !scope.navbarOpen;
								scope.notification({
									action: 'opened',
									options: scope.navbarOpen
								});
							};
						},
						controller: ['$scope', function($scope) {

							}]
					};
				}]);
})(angular);
